import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

import { RiInformationLine } from 'react-icons/ri';
import ExternalLink from 'components/ExternalLink';
import { Trans, useTranslation } from 'services/localization';

type LinkLabelVariant = 'inventory' | 'domains' | 'inventoryImport' | 'customizations';

interface Props {
	linkHref: string;
	labelVariant: LinkLabelVariant;
	alignment?: 'center' | 'flex-start' | 'flex-end';
	showIcon?: boolean;
}

const LearnMore = (props: Props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const { linkHref, labelVariant, alignment = 'center', showIcon = true } = props;

	const getLabelLocalization = (label: LinkLabelVariant) => {
		const labelLocale: Record<LinkLabelVariant, string> = {
			inventory: t('learnMore.inventory', 'inventory'),
			domains: t('learnMore.domains', 'domains'),
			inventoryImport: t('learnMore.inventoryImport', 'inventory import'),
			customizations: t('learnMore.customizations', 'customizations'),
		};
		return labelLocale[label] ?? label;
	};

	return (
		<Box display="flex" justifyContent={alignment} alignItems="center">
			{showIcon && (
				<Box mr={1}>
					<RiInformationLine color={theme.palette.colors.tundra.main} />{' '}
				</Box>
			)}
			<Typography variant="body2" color="secondary">
				<Trans
					i18nKey="learnMore.base"
					defaults="Learn more about <supportLink>{{linkLabel}}</supportLink>"
					values={{
						linkLabel: getLabelLocalization(labelVariant),
					}}
					components={{
						supportLink: (
							<ExternalLink href={linkHref}>{getLabelLocalization(labelVariant)}</ExternalLink>
						),
					}}
				/>
			</Typography>
		</Box>
	);
};

export default LearnMore;
